import React from 'react';
import FamilyGroupRow from './FamilyGroupRow';

function FamilyGroupTable({ familyGroups, onEdit, onDelete, onSort, sortBy, organizationsParent }) {
  sortBy = sortBy ? JSON.parse(sortBy) : {};
  
  const handleHeaderClick = (column) => {
    if (onSort) {
      onSort(column);
    }
  };

  return (
    <table className="w-full table-auto">
      <thead>
        <tr>
          <th
            onClick={() => handleHeaderClick("nombre")}
            className={`cursor-pointer px-4 py-2 text-left`}
          >
            Nombre{" "}
            {(sortBy.column === "nombre" && (sortBy.isAscending ? "↑" : "↓")) || "↑↓"}
          </th>
          <th className="px-4 py-2 text-left">Organización</th>
          <th
            onClick={() => handleHeaderClick("createdAt")}
            className={`cursor-pointer px-4 py-2 text-left`}
          >
            Fecha de creación{" "}
            {(sortBy.column === "createdAt" && (sortBy.isAscending ? "↑" : "↓")) || "↑↓"}
          </th>
          <th
            onClick={() => handleHeaderClick("isActive")}
            className={`cursor-pointer px-4 py-2 text-left`}
          >
            Activa{" "}
            {(sortBy.column === "isActive" && (sortBy.isAscending ? "↑" : "↓")) || "↑↓"}
          </th>
          <th className="px-4 py-2 text-left">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {familyGroups && familyGroups.length > 0 ? (
          familyGroups.map(group => (
            <FamilyGroupRow 
              key={group._id}
              familyGroup={group} 
              onEdit={onEdit} 
              onDelete={onDelete} 
              organizationsParent={organizationsParent}
            />
          ))
        ) : (
          <tr>
            <td colSpan="5" className="text-center py-4">No hay grupos familiares existentes</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default FamilyGroupTable;
